import { render, staticRenderFns } from "./TextWithIcon.vue?vue&type=template&id=1ce9e5cd"
import script from "./TextWithIcon.vue?vue&type=script&lang=js"
export * from "./TextWithIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports